export const API = 'https://iurr9y4cu1.execute-api.ap-south-1.amazonaws.com/app/menu' 